import {
  actionTypes,
  generateOtpRequestFailure,
  generateOtpRequestSuccess,
  getResetPwdSecurityQuestionsFailure,
  getResetPwdSecurityQuestionsSuccess,
  userAccountRequestFailure,
  userAccountRequestSuccess,
  verifyResetUigpOtpActionFailure,
  verifyResetUigpOtpActionSuccess,
  verifyResetQuestionsActionFailure,
  verifyResetQuestionsActionSuccess,
  verifyResetArcotOtpActionSuccess,
  verifyResetArcotOtpActionFailure,
  forcedResetRequestActionSuccess,
  forcedResetRequestActionFailure,
} from "./actions";

import {
  fetchGetSecurityQuestionsReset,
  fetchUserAccountRequest,
  forcedResetService,
  generateUigpOTP,
  verifyArcotResetService,
  verifySecurityQuestionsResetService,
  verifyUigpOTP,
} from "./services";

import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";

const fetchUserAccountRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.USER_ACCOUNT_REQUEST_RESET_PASSWORD),
    mergeMap(() => {
      return fetchUserAccountRequest().pipe(
        map((response: any) => userAccountRequestSuccess(response)),
        catchError((error: any) => of(userAccountRequestFailure(error)))
      );
    })
  );

const fetchForcedResetPwdEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FORCED_RESET_PWD),
    mergeMap((action: any) =>
      forcedResetService(action.payload).pipe(
        map((response: any) => forcedResetRequestActionSuccess(response)),
        catchError((error: any) => of(forcedResetRequestActionFailure(error)))
      )
    )
  );

const fetchGetSecurityQuestionsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_RESET_PWD_QUESTIONS),
    mergeMap((action: any) =>
      fetchGetSecurityQuestionsReset().pipe(
        map((response: any) => getResetPwdSecurityQuestionsSuccess(response)),
        catchError((error: any) =>
          of(getResetPwdSecurityQuestionsFailure(error))
        )
      )
    )
  );

const generateUigpOtpEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GENERATE_UIGP_OTP_REQUEST),
    mergeMap((action: any) =>
      generateUigpOTP(action.payload).pipe(
        map((response: any) => generateOtpRequestSuccess(response)),
        catchError((error: any) => of(generateOtpRequestFailure(error)))
      )
    )
  );

const verifyArcotOtpEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.VERIFY_RESET_ARCOT_OTP_REQUEST),
    mergeMap((action: any) =>
      verifyArcotResetService(action.payload).pipe(
        map((response: any) => verifyResetArcotOtpActionSuccess(response)),
        catchError((error: any) => of(verifyResetArcotOtpActionFailure(error)))
      )
    )
  );

const verifyUigpOtpEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.VERIFY_RESET_UIGP_OTP_REQUEST),
    mergeMap((action: any) =>
      verifyUigpOTP(action.payload).pipe(
        map((response: any) => verifyResetUigpOtpActionSuccess(response)),
        catchError((error: any) => of(verifyResetUigpOtpActionFailure(error)))
      )
    )
  );

const verifyResetSecurityQuestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.VERIFY_RESET_SEC_QUESTIONS),
    mergeMap((action: any) =>
      verifySecurityQuestionsResetService(action.payload).pipe(
        map((response: any) => verifyResetQuestionsActionSuccess(response)),
        catchError((error: any) => of(verifyResetQuestionsActionFailure(error)))
      )
    )
  );

export default [
  fetchUserAccountRequestEpic,
  verifyArcotOtpEpic,
  fetchGetSecurityQuestionsEpic,
  generateUigpOtpEpic,
  verifyUigpOtpEpic,
  verifyResetSecurityQuestEpic,
  fetchForcedResetPwdEpic,
];
